// Packages:
import React, { memo, useCallback } from "react";
import { Position } from "react-flow-renderer";
import './styles.css'

// Styles:
import { Wrapper, Title } from "./styles";
import Scrollbars from "react-custom-scrollbars-2";
import { NodeLabel, NodeWrapper } from "../Nodes/styles";

// Constants:
const DEFAULT_TEMPLATE = `{
  "_success": {
    "_on": "true",
    "_output": {
      "variableName": "res.body.variableName"
    }
  },
  "_failure": {
    "_on": "res.status != 200",
    "_output": {
      "error": "res.error || res.status.error"
    }
  }
}`;

const centredText = () => {
  return { display: "flex", alignItems: "center", justifyContent: "center" };
};
const commonNodeStyles = () => {
  return {
    marginBottom: "1rem",
    paddingBottom: "0.5rem",
    textAlign: "center",
    cursor: "grab",
  };
};

const nodes = [
  { type: "start", borderColor: "#3AA640", data: { comment: "", tags: [],label: "START" } },
  { type: "acuity", borderColor: "#008060", data: { action: "GET AVAILABILITY", label: "ACUITY" } },
  { type: "api", borderColor: "#7721E8", data: { action: "GET", endpoint: "", label: "API" } },
  { type: "choice", borderColor: "#7721e8", data: { label: "CHOICE"} },
  { type: "decision", borderColor: "#FE7920", data: { orderId: "", decisionType: "BINARY", options: [],label: "DECISION" } },
  { type: "email", borderColor: "#D43558", data: {label: "EMAIL"} },
  { type: "form", borderColor: "#4F5450", data: { formName: "", formDescription: "", label: "FORM" } },
  { type: "google_sheets", borderColor: "#188038", data: { operation: "create", sheet_name: "", sheet_baseurl: "", credentials: "", data: [], filter: [],label: "GOOGLE SHEETS" } },
  { type: "logistics",  borderColor: "#FE7920", data: { userId: '' ,label: "LOGISTICS"} },
  { type: "message", borderColor: "#401FFF", data: { message: "", formName: "", expectResponse: false, responsesExpected: 0, outputs: [], options: [],label: "MESSAGE" } },
  { type: "parallel",  borderColor: "#FE7920", data: {label: "PARALLEL"} },
  { type: "parallelHandler", borderColor: "#FE7920", data: { label: "PARALLEL END"} },
  { type: "ai", borderColor: "#7721E8", data: { action: "GENERATE_AI_RESPONSE", label: "READYLY AI" } },
  { type: "shipping", borderColor: "#747458", data: { carrier: "SHIPPING EASY", shippingEasyAction: "order_details", shippingType: "FIRST CLASS MAIL", label: "SHIPPING"} },
  { type: "shopify", borderColor: "#008060", data: { shopifyAction: "order_fulfillment_details", label: "SHOPIFY" } },
  { type: "ticket", borderColor: "#235789", data: { ticketChannel: "ZENDESK", ticketAction: "CREATE", tags: [], informationToExtract: [], macros: [], includedSearchTerms: [], excludedSearchTerms: [], customFields: "", channel: "NONE", status: "NONE", searchFilter: { status: [] }, label: "TICKET", } },
  { type: "ticketure", borderColor: "#235789", data: { label: "TICKETURE"} },
  { type: "leaf", borderColor: "#DB4C40", data: { handlePosition: Position.Top, isEndNode: true, label: "END" } },
];

const Assets = () => {
  const onDragStart = useCallback((event, nodeType, data) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.setData("data", JSON.stringify(data));
    event.dataTransfer.effectAllowed = "move";
  }, []);

  return (
    <Wrapper>
      <Scrollbars>
        <Title>Asset</Title>
        {nodes.map((node, index) => (
          <NodeWrapper
            key={node.type}
            style={{
              ...commonNodeStyles(),
              border: `2px solid ${node.borderColor}`,
              ...centredText(),
            }}
            onDragStart={(event) => onDragStart(event, node.type, node.data)}
            backgroundColor={'#FEFFFE'}
            borderColor={node.borderColor}
            draggable
          >
            <NodeLabel style={centredText()}>{node.data.label}</NodeLabel>
          </NodeWrapper>
        ))}
      </Scrollbars>
    </Wrapper>
  );
};

export default memo(Assets);